import { useMutation, UseMutationResult, useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { klwAxios, setKringloopwijzerId } from 'helpers/api';
import { KlwMenu, Voorwaarden } from '../types/menu';
import { notification } from 'antd';
import { AxiosError } from 'axios';

const QUERY_KEY = ['Menu'];
export const useGetMenu = (enabled = true): UseQueryResult<KlwMenu> => {
  const klwId = localStorage.getItem('KringloopwijzerId') ?? undefined;

  const query = useQuery({
    queryKey: [...QUERY_KEY, klwId],
    enabled,
    queryFn: () =>
      klwAxios.get<KlwMenu>('Menu/GetMenu').then(res => {
        setKringloopwijzerId(res.data.kringloopwijzerId);
        return res.data;
      }),
  });

  if (!enabled) return { ...query, isLoading: false, isFetching: false } as UseQueryResult<KlwMenu>;
  return query;
};

export const useGetVoorwaarden = (enabled = true): UseQueryResult<Voorwaarden[]> => {
  const query = useQuery({
    queryKey: ['Voorwaarden'],
    enabled,
    queryFn: () =>
      klwAxios.get<Voorwaarden[]>('Menu/GetOngelezenVoorwaarden').then(res => {
        return res.data;
      }),
  });

  if (!enabled) return { ...query, isLoading: false, isFetching: false } as UseQueryResult<Voorwaarden[]>;
  return query;
};

export const useAcceptVoorwaarden = (): UseMutationResult<void, unknown, number, unknown> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (voorwaardeId: number) => klwAxios.post('Menu/AccepteerVoorwaarden', undefined, { params: { voorwaardeId: voorwaardeId } }).then(r => r.data),
    onSuccess: () => {
      notification.success({ message: 'Voorwaarden zijn geaccepteerd' });
      queryClient.invalidateQueries({ queryKey: ['Voorwaarden'] });
    },
    onError: (err: AxiosError<{ message: string }>) => {
      notification.error({ message: err.response?.data.message });
    },
  });
};
